import { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import arrow from "../../assets/at-details/arrow-down.svg";

export const IntroContainer = styled.div`
  height: 100vh;
  background-color: var(--cardgrey);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ColumnContainer = styled.div`
 display: flex;
 flex-direction: column;
 justify-content: flex-end;
 align-items: flex-start;
 padding: 0 38px;
`;

export const DecorativeLine = styled.div`
  width: 50px;
  height: 6px;
  background-color: var(--bg-pink);
  margin-left: 0;
  margin-bottom: 18px;
  border-radius: 0 5px 5px 0;
`;


export const StartIntroH1 = styled.h1`
    font-size: 28px;
    font-weight: 500;
    color: var(--maindark);
    margin: 0 ; 

  @media (min-width: 768px) {
    font-size: 38px;
  }

  @media (min-width: 1024px) {
    font-size: 48px;
  }
`;

export const StartIntroP = styled.p`
    font-size: 16px;
    color: var(--maindark);
    margin: 17px 0;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 1.2;
    max-width: 600px;
    text-align: left;

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 1024px) {
    font-size: 22px;
  }
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); } 
  10% { transform: translateY(-15px); }
  20% { transform: translateY(0); }
  30% { transform: translateY(-10px); }
  40% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
  60% { transform: translateY(0); }
  70% { transform: translateY(-5px); }
  80% { transform: translateY(0); }
`;

interface BounceArrowProps {
  $isAnimating: boolean;
}

const BounceArrow = styled.img<BounceArrowProps>`
  width: 30px;
  height: auto;
  opacity: ${({ $isAnimating }) => ($isAnimating ? 1 : 0)};
  transition: opacity 0.2s ease;
  animation: ${({ $isAnimating }) => ($isAnimating ? bounce : "none")} 1.5s ease-in-out 1;
  cursor: pointer;
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 85%; 
  left: 50%; 
  transform: translate(-50%, 40px);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    top: 80%;
  }
`;

export const DownArrow: React.FC = () => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    let animationTimeout: NodeJS.Timeout;
    let pauseTimeout: NodeJS.Timeout;

    const startAnimation = () => {
      setIsAnimating(true);
      animationTimeout = setTimeout(() => {
        setIsAnimating(false);
        pauseTimeout = setTimeout(startAnimation, 3000);
      }, 1500);
    };

    const initialDelay = setTimeout(startAnimation, 3000);

    return () => {
      clearTimeout(initialDelay);
      clearTimeout(animationTimeout);
      clearTimeout(pauseTimeout);
    };
  }, []);

  const handleClick = () => {
    console.log("Arrow clicked!");
    window.scrollBy({ top: window.innerHeight, behavior: "smooth" });
  };

  return (
    <ArrowButton onClick={handleClick} aria-label="Scroll down">
      <BounceArrow src={arrow} alt="Scroll down" $isAnimating={isAnimating} />
    </ArrowButton>
  );
};

// From old intro, keep until new intro is done
export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--mainlight);
  height: 97vh;
`;
